import React, { useEffect, useState } from "react";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import SectionWrapper, {
    FormField,
} from "pages/createMission/components/SectionWrapper";
import MultiDdl from "components/componentsForm/multiDdl";
import MonoSelect from "components/componentsForm/monoSelect";
import TemplateToolList from "pages/missionTemplates/components/TemplateToolList";
import {
    DEFAULT_TOOL_PROVIDER,
    normalizeTemplateTools,
    toolNameKey,
} from "pages/missionTemplates/utils/templateTools";

const PrerequisTemplate = () => {
    const { templateData, setTemplateData, language } = UseContext();
    const [toolReferential, setToolReferential] = useState([]);
    const [licences, setLicences] = useState([]);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        ApiDataBase.getAllLicence(
            (res) => setLicences(res),
            (err) => console.warn(err)
        );
        ApiDataBase.getListTools(
            (res) => setToolReferential(res),
            (err) => console.warn(err)
        );
        ApiDataBase.getListLanguages(
            (res) => setLanguages(res),
            (err) => console.warn(err)
        );
    }, []);

    // The rows are the source of truth: a tool missing from the referential
    // (renamed or removed since) must stay visible and removable.
    const selectedTools = templateData.tools || [];
    const selectedToolKeys = new Set(
        selectedTools.map((tool) => toolNameKey(tool.name))
    );
    const availableTools = normalizeTemplateTools(
        Array.isArray(toolReferential)
            ? toolReferential.map((tool) => tool?.name)
            : []
    ).filter((tool) => !selectedToolKeys.has(toolNameKey(tool.name)));

    const updateTools = (update) =>
        setTemplateData((prev) => ({
            ...prev,
            tools: update(prev.tools || []),
        }));
    const handleAddTool = (option) => {
        if (!option?.value) return;
        updateTools((tools) => [
            ...tools,
            { name: option.value, providedBy: DEFAULT_TOOL_PROVIDER },
        ]);
    };
    const handleToolProviderChange = (name, providedBy) =>
        updateTools((tools) =>
            tools.map((tool) =>
                tool.name === name ? { ...tool, providedBy } : tool
            )
        );
    const handleRemoveTool = (name) =>
        updateTools((tools) => tools.filter((tool) => tool.name !== name));
    const handleLicences = (selected) =>
        setTemplateData((prev) => ({ ...prev, licences: selected }));
    const handleLanguages = (selected) =>
        setTemplateData((prev) => ({ ...prev, languages: selected }));

    return (
        <SectionWrapper
            title="Pré-requis"
            description="Indiquez les compétences et équipements nécessaires."
        >
            <FormField label="Matériel nécessaire" optional>
                <MonoSelect
                    data={availableTools}
                    selectArray={handleAddTool}
                    placeholder={language.getValue(
                        "missionTemplate.tools.addPlaceholder",
                        "Sélectionner"
                    )}
                    noOptionsMessage={language.getValue(
                        "missionTemplate.tools.noOptions",
                        "Aucun matériel disponible"
                    )}
                    ariaLabel={language.getValue(
                        "missionTemplate.tools.addLabel",
                        "Ajouter un matériel"
                    )}
                />
                <TemplateToolList
                    tools={selectedTools}
                    onProviderChange={handleToolProviderChange}
                    onRemove={handleRemoveTool}
                />
            </FormField>
            <FormField label="Permis nécessaire" optional>
                <MultiDdl
                    data={licences}
                    selectArray={handleLicences}
                    defaultSelect={templateData.licences || []}
                />
            </FormField>
            <FormField label="Langue nécessaire" optional>
                <MultiDdl
                    data={languages}
                    selectArray={handleLanguages}
                    defaultSelect={templateData.languages || []}
                />
            </FormField>
        </SectionWrapper>
    );
};

export default PrerequisTemplate;
